/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Access_Denied_BodyInputs */

const en_access_denied_body = /** @type {(inputs: Access_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account has no access to this area yet. Please contact your administrator.`)
};

const ja_access_denied_body = /** @type {(inputs: Access_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このエリアへのアクセス権がまだありません。管理者にお問い合わせください。`)
};

const fr_access_denied_body = /** @type {(inputs: Access_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte n'a pas encore accès à cette section. Veuillez contacter votre administrateur.`)
};

const de_access_denied_body = /** @type {(inputs: Access_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Konto hat noch keinen Zugriff auf diesen Bereich. Bitte wenden Sie sich an Ihre Administration.`)
};

/**
* | output |
* | --- |
* | "Your account has no access to this area yet. Please contact your administrator." |
*
* @param {Access_Denied_BodyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const access_denied_body = /** @type {((inputs?: Access_Denied_BodyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Access_Denied_BodyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_access_denied_body(inputs)
	if (locale === "ja") return ja_access_denied_body(inputs)
	if (locale === "fr") return fr_access_denied_body(inputs)
	return de_access_denied_body(inputs)
});